var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 308.248 308.248",
    xmlSpace: "preserve",
    fill: "",
    stroke: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: ""
    },
    d: "M277.812,222.656v-50.413c0-7.444-6.056-13.5-13.5-13.5H161.624v-43.436 c25.513-3.652,45.191-25.642,45.191-52.148c0-29.054-23.637-52.691-52.691-52.691c-29.054,0-52.691,23.638-52.691,52.691 c0,26.507,19.678,48.496,45.191,52.148v43.436H43.936c-7.444,0-13.5,6.056-13.5,13.5v50.413C13.099,226.147,0,241.494,0,259.845 c0,20.918,17.018,37.935,37.936,37.935c20.918,0,37.937-17.017,37.937-37.935c0-18.351-13.098-33.697-30.437-37.19v-48.912h101.188 v48.913c-17.338,3.491-30.436,18.838-30.436,37.189c0,20.918,17.018,37.935,37.936,37.935c20.918,0,37.936-17.017,37.936-37.935 c0-18.351-13.098-33.697-30.436-37.189v-48.913h101.188v48.912c-17.338,3.492-30.437,18.839-30.437,37.19 c0,20.918,17.018,37.935,37.937,37.935c20.918,0,37.936-17.017,37.936-37.935C308.248,241.494,295.149,226.147,277.812,222.656z M116.433,63.159c0-20.783,16.908-37.691,37.691-37.691c20.783,0,37.691,16.908,37.691,37.691s-16.908,37.691-37.691,37.691 C133.341,100.851,116.433,83.942,116.433,63.159z M60.873,259.845c0,12.646-10.289,22.935-22.937,22.935 C25.289,282.78,15,272.491,15,259.845c0-12.648,10.289-22.937,22.936-22.937C50.583,236.908,60.873,247.197,60.873,259.845z M177.06,259.845c0,12.646-10.289,22.935-22.936,22.935c-12.647,0-22.936-10.289-22.936-22.935 c0-12.648,10.289-22.937,22.936-22.937C166.771,236.908,177.06,247.197,177.06,259.845z M270.312,282.78 c-12.647,0-22.937-10.289-22.937-22.935c0-12.648,10.289-22.937,22.937-22.937c12.647,0,22.936,10.289,22.936,22.937 C293.248,272.491,282.959,282.78,270.312,282.78z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnection);
export default __webpack_public_path__ + "static/media/connection.644262cbeb2a193bcc43d98dfcccf310.svg";
export { ForwardRef as ReactComponent };